import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {RoomPartyOption} from '../../../graphql/groups.datatypes';

export interface UpdateRoomPartyOptionInput {
    data: {
        id: number
        room_party_id: number
        group_resource_option_id: number
        unit_count: number
        unit_cost: number
        admin_edited: boolean
    }
}

interface UpdateRoomPartyOptionData {
    updateRoomPartyOption: RoomPartyOption,
}

export const UPDATE_ROOM_PARTY_MEMBER_OPTION_MUTATION = gql`
  mutation updateRoomPartyOption($data: UpdateRoomPartyOptionInput!){
    updateRoomPartyOption(data: $data) {
      id
      room_party_id
      group_resource_option_id
      unit_count
      unit_cost
      admin_edited
    }
  }
`;

export const updateRoomPartyOption = () => {
    return useMutation<UpdateRoomPartyOptionData, UpdateRoomPartyOptionInput>(
        UPDATE_ROOM_PARTY_MEMBER_OPTION_MUTATION,
        {
            update: updateCacheByType('RoomPartyOption'),
        }
    );
};

export default updateRoomPartyOption;